<div class="list-parts" [style]="isMaxContent">
  <!-- Floating Teams Tooltip Container -->
  <div
    class="teams-tooltip fixed z-50 bg-white border border-gray-200 rounded-lg shadow-lg p-2.5 min-w-max whitespace-nowrap pointer-events-auto max-w-52"
    [style.display]="currentTooltipUser && currentTooltipUser.showTeamsTooltip ? 'block' : 'none'"
    [style.top.px]="tooltipPosition.top" [style.left.px]="tooltipPosition.left" (mouseenter)="tooltipHovered = true"
    (mouseleave)="tooltipHovered = false; clearTooltip()">

    <div class="font-semibold mb-1.5 text-sm text-gray-800">Teams</div>
    <div class="flex flex-wrap max-w-52 gap-1">
      <div *ngFor="let team of currentTooltipUser?.selectedTeam?.slice(1)"
        class="w-auto py-1 px-4 border-gray-200 border border-solid bg-gray-100 rounded-3xl text-sm text-gray-600 my-1">
        {{ team }}</div>
    </div>
  </div>

  <!-- Floating Health & Integrity Tooltip Container -->
  <div
    class="health-tooltip-card fixed z-[1050] bg-white border border-gray-200 rounded-xl shadow-2xl p-4 w-[360px] pointer-events-auto"
    [style.display]="currentHealthTooltipUser && currentHealthTooltipUser.showHealthTooltip ? 'block' : 'none'"
    [style.top.px]="healthTooltipPosition.top" [style.left.px]="healthTooltipPosition.left"
    (mouseenter)="healthTooltipHovered = true" (mouseleave)="healthTooltipHovered = false; clearHealthTooltip()">

    <!-- Tooltip Header -->
    <div class="flex items-center justify-between !pb-1 !mb-1 border-b border-gray-100">
      <div class="flex items-center gap-2">
        <span class="material-symbols-outlined text-[20px] text-gray-700">shield</span>
        <div>
          <div class="font-semibold text-sm text-gray-900 leading-tight">Client Agent Health</div>
        </div>
      </div>
      <div [ngSwitch]="getUserHealthState(currentHealthTooltipUser)">
        <span *ngSwitchCase="'HEALTHY'"
          class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800 flex items-center gap-1">
          <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
          Healthy
        </span>
        <span *ngSwitchCase="'UNHEALTHY'"
          class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-rose-100 text-rose-800 flex items-center gap-1">
          <span class="w-1.5 h-1.5 rounded-full bg-rose-500 animate-pulse"></span>
          Unhealthy
        </span>
        <span *ngSwitchCase="'STARTING'"
          class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-800 flex items-center gap-1">
          <span class="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
          Starting
        </span>
        <span *ngSwitchCase="'LOGOUT'"
          class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-700 flex items-center gap-1">
          <span class="w-1.5 h-1.5 rounded-full bg-gray-500"></span>
          Logout
        </span>
        <span *ngSwitchCase="'UNINSTALLED'"
          class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-700 flex items-center gap-1">
          <span class="w-1.5 h-1.5 rounded-full bg-gray-500"></span>
          Uninstalled
        </span>
        <span *ngSwitchDefault class="px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-600">
          Unknown
        </span>
      </div>
    </div>

    <!-- Last Heartbeat Info -->
    <div class="flex items-center justify-between text-xs text-gray-500 mb-3 px-1 py-1.5">
      <span class="flex items-center gap-1">
        Last Checked :
      </span>
      <span class="font-medium text-gray-700">
        {{ currentHealthTooltipUser?.agentIntegrity?.lastHeartbeatAtUtc ?
        (formatHealthTimestamp(currentHealthTooltipUser.agentIntegrity.lastHeartbeatAtUtc) + ' (' +
        getHealthRelativeTime(currentHealthTooltipUser.agentIntegrity.lastHeartbeatAtUtc) + ')') : 'No heartbeat yet' }}
      </span>
    </div>

    <!-- Active Failure Card (Only if latest is Unhealthy) -->
    <div *ngIf="getUserHealthState(currentHealthTooltipUser) === 'UNHEALTHY'"
      class="mb-3 p-2.5 rounded-lg bg-red-50 border border-red-200">
      <div class="flex items-center gap-2">
        <span class="material-symbols-outlined text-[18px] text-red-600 flex-shrink-0">error</span>
        <div class="flex-1 min-w-0">
          <div
            *ngIf="getHumanReadableReasonList(getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode).length > 1; else singleReason"
            class="space-y-1.5">
            <div
              *ngFor="let r of getHumanReadableReasonList(getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode)"
              class="text-xs text-red-700 leading-snug flex items-start gap-1.5">
              <span class="text-red-400 mt-0.5 text-[8px]">•</span>
              <span class="font-medium">{{ r }}</span>
            </div>
          </div>
          <ng-template #singleReason>
            <p class="text-xs text-red-700 leading-snug !m-0 font-medium">
              {{
              getHumanReadableReason(getLatestHealthEntry(currentHealthTooltipUser)?.reasonCode)
              }}
            </p>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- History Logs Section -->
    <div>
      <div class="flex items-center justify-between mb-2">
        <span class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Health History</span>
        <span class="text-[11px] text-gray-400 font-normal">
          {{ getHealthHistory(currentHealthTooltipUser).length }} log(s)
        </span>
      </div>

      <div *ngIf="getHealthHistory(currentHealthTooltipUser).length > 0; else noHistory"
        class="space-y-2 max-h-48 overflow-y-auto pr-1">
        <div *ngFor="let item of getHealthHistory(currentHealthTooltipUser); let idx = index"
          class="p-2 rounded-lg border text-xs" [ngClass]="{
                 'border-emerald-200 bg-emerald-50/60': getHealthItemState(item) === 'HEALTHY',
                 'border-red-200 bg-red-50/60': getHealthItemState(item) === 'UNHEALTHY',
                 'border-blue-200 bg-blue-50/60': getHealthItemState(item) === 'STARTING',
                 'border-gray-200 bg-gray-50': getHealthItemState(item) !== 'HEALTHY' && getHealthItemState(item) !== 'UNHEALTHY' && getHealthItemState(item) !== 'STARTING'
               }">
          <div class="flex items-center justify-between mb-1">
            <div class="flex items-center gap-1.5">
              <span class="w-2 h-2 rounded-full" [ngClass]="{
                        'bg-emerald-500': getHealthItemState(item) === 'HEALTHY',
                        'bg-red-500': getHealthItemState(item) === 'UNHEALTHY',
                        'bg-blue-500': getHealthItemState(item) === 'STARTING',
                        'bg-gray-400': getHealthItemState(item) !== 'HEALTHY' && getHealthItemState(item) !== 'UNHEALTHY' && getHealthItemState(item) !== 'STARTING'
                      }"></span>
              <span class="font-semibold text-[11px]" [ngClass]="{
                        'text-emerald-800': getHealthItemState(item) === 'HEALTHY',
                        'text-red-800': getHealthItemState(item) === 'UNHEALTHY',
                        'text-blue-800': getHealthItemState(item) === 'STARTING',
                        'text-gray-700': getHealthItemState(item) !== 'HEALTHY' && getHealthItemState(item) !== 'UNHEALTHY' && getHealthItemState(item) !== 'STARTING'
                      }">
                {{ getHealthItemState(item) }}
              </span>
              <span *ngIf="idx === 0" class="text-[9px] px-1 py-0.2 bg-gray-200 text-gray-600 rounded">Current</span>
            </div>
            <span class="text-[10px] text-gray-500">{{ formatHealthTimestamp(item.timestampUtc) }}</span>
          </div>

          <div *ngIf="getHealthItemState(item) === 'UNHEALTHY'" class="text-[11px] text-red-700 mt-1">
            <div *ngIf="getHumanReadableReasonList(item.reasonCode).length > 1; else singleItemReason"
              class="space-y-1">
              <div *ngFor="let r of getHumanReadableReasonList(item.reasonCode)"
                class="flex items-start gap-1 min-w-0 flex-1">
                <span class="text-red-400 text-[8px] mt-0.5">•</span>
                <span>{{ r }}</span>
              </div>
            </div>
            <ng-template #singleItemReason>
              <div class="min-w-0 flex-1">{{ getHumanReadableReason(item.reasonCode) }}</div>
            </ng-template>
          </div>
          <div *ngIf="getHealthItemState(item) === 'LOGOUT'" class="text-[11px] text-gray-600 mt-0.5">
            User logged out
          </div>
          <div *ngIf="getHealthItemState(item) === 'HEALTHY'" class="text-[11px] text-emerald-700">
            All system health checks passing
          </div>
          <div *ngIf="getHealthItemState(item) === 'STARTING'" class="text-[11px] text-blue-700">
            Agent client initializing services
          </div>
          <div *ngIf="getHealthItemState(item) === 'UNINSTALLED'" class="text-[11px] text-gray-600">
            Client agent uninstalled
          </div>
        </div>
      </div>

      <ng-template #noHistory>
        <div class="py-4 text-center text-xs text-gray-400 italic bg-gray-50 rounded-lg">
          No integrity history recorded yet
        </div>
      </ng-template>
    </div>
  </div>

  <table matSort (matSortChange)="sortData($event)" class="highlight centered users-table">
    <thead>
      <tr class="table-head">
        <th>#</th>
        <th mat-sort-header="Employee Name">Employee name</th>
        <th mat-sort-header="status">Status</th>
        <th mat-sort-header="screenshot">Last screenshot</th>
        <th mat-sort-header="usedApps">Last app used</th>
        <th *ngIf="isHideTeams != true">Team</th>
        <th tourAnchor="requestEmployeeActions">Actions</th>
      </tr>
    </thead>
    <tbody *ngIf="!loadWaiter">
      <tr *ngFor="let user of filteredUserList; let i = index; trackBy: trackByUserId" class="user-list-row">
        <!-- Index Column -->
        <td class="index-cell">{{ getRowNumber(i) }}</td>
        <!-- User Profile Column -->
        <td class="user-profile-cell">
          <div class="user-profile-with-alerts">
            <user-profile *ngIf="!expired" [routerLink]="['/user-details/', user.id]" [user]="user"
              [userImageClass]="userImageClass" [sizeAvatar]="34" [showHealth]="true">
            </user-profile>
            <user-profile *ngIf="expired" [user]="user" [userImageClass]="userImageClass" [sizeAvatar]="34">
            </user-profile>
            <span *ngIf="isCriticallyOutdated(user)"
              class="version-alert-dot version-critical-icon material-symbols-outlined"
              [matTooltip]="getVersionWarningTooltip(user)" matTooltipPosition="above">cancel</span>
            <span *ngIf="isWarningVersion(user)"
              class="version-alert-dot version-warning-icon material-symbols-outlined"
              [matTooltip]="getVersionWarningTooltip(user)" matTooltipPosition="above">warning</span>
          </div>
        </td>

        <!-- Role Column -->
        <!-- <td class="role-cell">
          {{ getUserRole(user.role) }}
        </td> -->

        <!-- Status Column -->
        <td class="status-cell">
          <div [ngSwitch]="getUserStatusType(user)" class="status-container">
            <!-- Auto Logout Status -->
            <div *ngSwitchCase="'auto-logout'" class="status-wrapper" [matTooltip]="getAutoLogoutTooltip(user)">
              <div class="auto-logout-status online-offline-status-color-auto-logout">
                Auto Logout
              </div>
              <div class="status-caption" *ngIf="getPresenceCaption(user)">{{ getPresenceCaption(user) }}</div>
            </div>

            <!-- Idle Status -->
            <div *ngSwitchCase="'idle'" class="status-wrapper status_block" [matTooltip]="getIdleTooltip(user)">
              <div class="online-offline-status online-offline-status-color-idle">
                Idle
              </div>
              <div class="status-caption" *ngIf="getPresenceCaption(user)">{{ getPresenceCaption(user) }}</div>
            </div>

            <!-- Offline Status -->
            <div *ngSwitchCase="'offline'" class="status-wrapper" [matTooltip]="getOfflineTooltip(user)">
              <div class="online-offline-status online-offline-status-color-offline">
                Offline
              </div>
              <div class="status-caption" *ngIf="getPresenceCaption(user)">{{ getPresenceCaption(user) }}</div>
              <div class="signed-out-at" *ngIf="getSignedOutLabel(user)">{{ getSignedOutLabel(user) }}</div>
              <div class="signed-out-at" *ngIf="getPasswordResetLabel(user)">{{ getPasswordResetLabel(user) }}</div>
            </div>

            <div *ngSwitchCase="'absent'" class="status-wrapper" [matTooltip]="getOfflineTooltip(user)">
              <div class="online-offline-status online-offline-status-color-absent">
                Absent
              </div>
              <div class="status-caption" *ngIf="getPresenceCaption(user)">{{ getPresenceCaption(user) }}</div>
              <div class="signed-out-at" *ngIf="getSignedOutLabel(user)">{{ getSignedOutLabel(user) }}</div>
              <div class="signed-out-at" *ngIf="getPasswordResetLabel(user)">{{ getPasswordResetLabel(user) }}</div>
            </div>

            <!-- Online Status -->
            <div *ngSwitchCase="'online'" class="status-wrapper status_block">
              <div class="online-offline-status online-offline-status-color-online">
                Online
              </div>
            </div>

            <!-- Invited Status -->
            <div *ngSwitchCase="'invited'" class="status-wrapper status_block">
              <div class="online-offline-status online-offline-status-color-away" #invitedBadge>
                Invited
              </div>
              <div class="status-caption">{{ getPresenceCaption(user) }}</div>
            </div>
          </div>
        </td>

        <!-- Last Screenshot Column -->
        <td class="screenshot-cell" [class.screenshot-cell--quiet]="isActivityQuiet(user)"
          [matTooltip]="getScreenshotTooltip(user)">
          {{ getScreenshotDisplay(user) }}
        </td>

        <!-- Last App Column -->
        <td class="app-cell" [class.app-cell--quiet]="isActivityQuiet(user)">
          {{ isLiveActivityStatus(user) && !isStaleScreenshot(user) ?
          getLastApplication(user.meta?.last_application_name) : '--' }}
        </td>

        <!-- Team Column -->
        <td class="team-cell overflow-visible" *ngIf="isHideTeams != true">
          <div *ngIf="user.selectedTeam && user.selectedTeam != '-' && user.selectedTeam.length > 0; else noTeams"
            class="selectedUsersTeams overflow-visible">
            <div class="selectedTeam">
              {{ user.selectedTeam[0] }}
            </div>
            <div class="inline-block relative overflow-visible"
              *ngIf="user.selectedTeam.length && user.selectedTeam.length > 1" #teamsBadge
              (mouseenter)="user.showTeamsTooltip = true; updateTooltipPosition($event, user)"
              (mouseleave)="user.showTeamsTooltip = false; !tooltipHovered && clearTooltip()">
              <div class="selectedTeam cursor-default">
                +{{user.selectedTeam.length - 1}}
              </div>
            </div>
          </div>
          <ng-template #noTeams>
            -
          </ng-template>
        </td>

        <!-- Actions Column (primary peek + unified more menu) -->
        <td class="actions-cell">
          <div class="actions-container actions-container--unified" *ngIf="(getUserStatusType(user) != 'invited')">
            <button type="button" class="live-peek-btn"
              *ngIf="!expired && (user.status === 'online' || user.status == 'idle')"
              (click)="handleScreencastRequest(user)"
              matTooltip="Watch live screen">
              <span class="material-symbols-outlined" aria-hidden="true">cast</span>
              <span class="live-peek-label">Watch live</span>
            </button>

            <span class="action-icon material-symbols-outlined more-actions cursor-pointer"
              [matMenuTriggerFor]="moreMenu" matTooltip="More actions">
              more_horiz
            </span>

            <mat-menu #downloadMenu="matMenu" xPosition="before">
              <button mat-menu-item *ngIf="!isDownloadSoftwareTypeLocked('silent')"
                [matMenuTriggerFor]="invisibleTracking">
                Hidden
                <i class="menu-info-icon material-icons" [matTooltip]="invisibleTrackingTooltip"
                  matTooltipPosition="after">info_outline</i>
              </button>
              <button mat-menu-item *ngIf="isDownloadSoftwareTypeLocked('silent')" class="download-menu-item--locked"
                (click)="onLockedDownloadSoftwareTypeClick('silent')">
                Hidden
                <mat-icon class="download-menu-lock" aria-hidden="true">lock</mat-icon>
                <i class="menu-info-icon material-icons" [matTooltip]="invisibleTrackingTooltip"
                  matTooltipPosition="after">info_outline</i>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="selfControl">
                Employee Controlled
                <i class="menu-info-icon material-icons" [matTooltip]="selfControlTooltip"
                  matTooltipPosition="after">info_outline</i>
              </button>
              <button mat-menu-item *ngIf="!isDownloadSoftwareTypeLocked('restricted')"
                [matMenuTriggerFor]="adminControl">
                Admin Controlled
                <i class="menu-info-icon material-icons" [matTooltip]="adminControlTooltip"
                  matTooltipPosition="after">info_outline</i>
              </button>
              <button mat-menu-item *ngIf="isDownloadSoftwareTypeLocked('restricted')"
                class="download-menu-item--locked" (click)="onLockedDownloadSoftwareTypeClick('restricted')">
                Admin Controlled
                <mat-icon class="download-menu-lock" aria-hidden="true">lock</mat-icon>
                <i class="menu-info-icon material-icons" [matTooltip]="adminControlTooltip"
                  matTooltipPosition="after">info_outline</i>
              </button>
            </mat-menu>

            <mat-menu #selfControl="matMenu" xPosition="before">
              <button mat-menu-item (click)="downloadRustGeneralAgent(user)">
                Windows 10 &amp; 11
              </button>
              <button mat-menu-item *ngFor="let item of generalDownloads" (click)="downloadGeneralAgent(item.label)">
                {{ item.label }}
              </button>
            </mat-menu>

            <mat-menu #invisibleTracking="matMenu" xPosition="before">
              <button mat-menu-item (click)="autoResetPasswordRust('Windows', user)">
                Windows 10 &amp; 11
              </button>
              <button mat-menu-item *ngFor="let item of silentDownloads" (click)="autoResetPassword(item.label, user)">
                {{ item.label }}
              </button>
            </mat-menu>

            <mat-menu #adminControl="matMenu" xPosition="before">
              <button mat-menu-item (click)="downloadRustAdminControlAgent('Windows', user)">
                Windows 10 &amp; 11
              </button>
              <button mat-menu-item *ngFor="let item of generalDownloads"
                (click)="downloadAdminControlAgent(item.label, user)">
                {{ item.label }}
              </button>
            </mat-menu>

            <mat-menu #moreMenu="matMenu" xPosition="before" class="employee-actions-menu"
              panelClass="employee-actions-menu">
              <!-- Zone 1: Watch & review -->
              <div class="action-menu-group-label" (click)="$event.stopPropagation()">Watch &amp; review</div>

              <button type="button" mat-menu-item class="action-menu-item"
                [class.action-menu-item--disabled]="!isPresenceActionEnabled(user)"
                [matTooltip]="presenceActionDisabledTooltip(user)" matTooltipPosition="left"
                [matTooltipDisabled]="isPresenceActionEnabled(user)"
                (click)="trackTableActionMenu('live_peek'); handleScreencastRequest(user)">
                <span class="material-symbols-outlined action-menu-icon">cast</span>
                <span>Watch live</span>
              </button>

              <button type="button" mat-menu-item class="action-menu-item"
                [class.action-menu-item--disabled]="!isPresenceActionEnabled(user)"
                [matTooltip]="presenceActionDisabledTooltip(user)" matTooltipPosition="left"
                [matTooltipDisabled]="isPresenceActionEnabled(user)"
                (click)="trackTableActionMenu('screenshot'); handleScreenshotRequest(user)">
                <span class="material-symbols-outlined action-menu-icon">photo_camera</span>
                <span>Take screenshot</span>
              </button>

              <button type="button" mat-menu-item class="action-menu-item" *ngIf="!expired && showWorkReplayAction()"
                (click)="openWorkReplay(user)">
                <span class="material-symbols-outlined action-menu-icon">movie</span>
                <span>Work Replay</span>
                <mat-icon *ngIf="isWorkReplayLocked()" class="action-menu-lock" aria-hidden="true">lock</mat-icon>
              </button>

              <button type="button" mat-menu-item class="action-menu-item" *ngIf="!expired"
                (click)="openScreenshots(user)">
                <span class="material-symbols-outlined action-menu-icon">photo_library</span>
                <span>View screenshots</span>
              </button>

              <!-- Zone 2: Reports -->
              <mat-divider class="action-menu-divider"></mat-divider>
              <div class="action-menu-group-label" (click)="$event.stopPropagation()">Reports</div>

              <button type="button" mat-menu-item class="action-menu-item" *ngIf="!expired"
                [routerLink]="['/user-report/', user.id]" (click)="trackTableActionMenu('timesheet')">
                <span class="material-symbols-outlined action-menu-icon">summarize</span>
                <span>Timesheet</span>
              </button>

              <button type="button" mat-menu-item class="action-menu-item"
                *ngIf="!expired && showProductivityTrendsAction()" (click)="openProductivityTrends(user)">
                <span class="material-symbols-outlined action-menu-icon">timeline</span>
                <span>Productivity Trends</span>
                <mat-icon *ngIf="isProductivityTrendsLocked()" class="action-menu-lock"
                  aria-hidden="true">lock</mat-icon>
              </button>

              <button type="button" mat-menu-item class="action-menu-item" *ngIf="!expired"
                [routerLink]="['/user-details/', user.id]" (click)="trackTableActionMenu('visit_profile')">
                <span class="material-symbols-outlined action-menu-icon">person</span>
                <span>Open profile</span>
              </button>

              <!-- Zone 3: Management & security -->
              <mat-divider class="action-menu-divider"></mat-divider>
              <div class="action-menu-group-label" (click)="$event.stopPropagation()">Management &amp; security</div>

              <button type="button" mat-menu-item class="action-menu-item"
                *ngIf="isAdmin && checkIsActive() && !expired"
                (click)="trackTableActionMenu('edit'); openModalFire(user.id)">
                <span class="material-symbols-outlined action-menu-icon">edit</span>
                <span>Edit Employee</span>
              </button>

              <button type="button" mat-menu-item class="action-menu-item" *ngIf="(isAdmin || isManager) && !expired"
                [routerLink]="['/employee/setting/', user.id]" (click)="trackTableActionMenu('settings')">
                <span class="material-symbols-outlined action-menu-icon">tune</span>
                <span>Tracking Settings</span>
                <span *ngIf="hasPersonalizedSettings(user)"
                  class="tracking-settings-personal-badge"
                  matTooltip="This employee uses custom tracking settings"
                  matTooltipPosition="left">Custom</span>
              </button>

              <button type="button" mat-menu-item class="action-menu-item" *ngIf="isAdmin && !expired"
                [matMenuTriggerFor]="securityMenu">
                <span class="material-symbols-outlined action-menu-icon">lock_reset</span>
                <span>Security &amp; Passwords</span>
              </button>

              <!-- Zone 4: Technical & danger -->
              <mat-divider class="action-menu-divider"></mat-divider>
              <div class="action-menu-group-label" (click)="$event.stopPropagation()">Installer &amp; device</div>

              <!-- Device Health & Audit hidden for now
              <button type="button" mat-menu-item class="action-menu-item"
                *ngIf="showDeviceManagementAction()"
                (click)="openDeviceManagement(user)">
                <span class="material-symbols-outlined action-menu-icon">devices</span>
                <span>Device Health &amp; Audit</span>
                <mat-icon *ngIf="isDeviceManagementLocked()" class="action-menu-lock" aria-hidden="true">lock</mat-icon>
              </button>
              -->

              <button type="button" mat-menu-item class="action-menu-item" [matMenuTriggerFor]="downloadMenu"
                (click)="trackTableActionMenu('download_agent')">
                <span class="material-symbols-outlined action-menu-icon download-icon-wrapper">
                  download
                  <span *ngIf="hasVersionUpdate(user)" class="update-badge"></span>
                </span>
                <span>Download installer</span>
              </button>

              <button type="button" mat-menu-item [ngClass]="{
                      'text-red-600 font-medium': !isOutdatedVersion(user) && !isWarningVersion(user) && !isCriticallyOutdated(user) && (getUserHealthState(user) == 'UNHEALTHY' || getUserHealthState(user) == 'UNINSTALLED' || getUserHealthState(user) == 'LOGOUT'), 
                      'action-menu-item': true
                    }" [matMenuTriggerFor]="systemInformation" (click)="trackTableActionMenu('agent_info')">
                <span class="material-symbols-outlined action-menu-icon" *ngIf="isCriticallyOutdated(user)"
                  [matTooltip]="getVersionWarningTooltip(user)">cancel</span>
                <span class="material-symbols-outlined action-menu-icon" *ngIf="isWarningVersion(user)"
                  [matTooltip]="getVersionWarningTooltip(user)">warning</span>
                <span class="material-symbols-outlined action-menu-icon"
                  *ngIf="!isOutdatedVersion(user) && !(getUserHealthState(user) == 'UNHEALTHY' || getUserHealthState(user) == 'UNINSTALLED' || getUserHealthState(user) == 'LOGOUT')">info</span>
                <span class="material-symbols-outlined online animate-pulse transition-all font-semibold"
                  *ngIf="!isOutdatedVersion(user) && !isWarningVersion(user) && !isCriticallyOutdated(user) && (getUserHealthState(user) == 'UNHEALTHY' || getUserHealthState(user) == 'UNINSTALLED' || getUserHealthState(user) == 'LOGOUT')"
                  matTooltip="Desktop Agent Information">
                  error
                </span>
                <span>Agent Info</span>
              </button>

              <ng-container *ngIf="isAdmin && checkIsActive()">
                <mat-divider class="action-menu-divider"></mat-divider>
                <button type="button" mat-menu-item class="action-menu-item action-menu-item--danger"
                  (click)="trackTableActionMenu('delete'); deleteUser(user.id, user)">
                  <span class="material-symbols-outlined action-menu-icon">delete</span>
                  <span>Delete Employee</span>
                </button>
              </ng-container>
            </mat-menu>

            <mat-menu #securityMenu="matMenu" xPosition="before" class="employee-actions-menu"
              panelClass="employee-actions-menu">
              <button type="button" mat-menu-item class="action-menu-item"
                (click)="trackTableActionMenu('reset_password'); resetPassword(user)">
                <span class="material-symbols-outlined action-menu-icon">key</span>
                <span>Reset Password</span>
              </button>
              <button type="button" mat-menu-item class="action-menu-item"
                (click)="trackTableActionMenu('password_reset_history'); openPasswordResets(user)">
                <span class="material-symbols-outlined action-menu-icon">history</span>
                <span>Password Reset History</span>
              </button>
            </mat-menu>

            <mat-menu #systemInformation="matMenu" xPosition="before" class="employee-actions-menu"
              panelClass="employee-actions-menu" (closed)="clearHealthTooltip()">
              <div class="action-menu-info-row" matTooltip="Version" matTooltipPosition="before"
                (mouseenter)="clearHealthTooltip()">
                <span class="material-symbols-outlined action-menu-icon">release_alert</span>
                <span class="info-text">{{ user.appInfo?.version ? 'v-' + user.appInfo.version : 'N/A' }}</span>
              </div>
              <div *ngIf="shouldShowMode(user)" class="action-menu-info-row" matTooltip="Mode"
                matTooltipPosition="before" (mouseenter)="clearHealthTooltip()">
                <span class="material-symbols-outlined action-menu-icon">{{ getModeIcon(user) }}</span>
                <span class="info-text">{{ getModeTooltip(user) }}</span>
              </div>
              <div *ngIf="user.osInfo?.os" class="action-menu-info-row" matTooltip="OS" matTooltipPosition="before"
                (mouseenter)="clearHealthTooltip()">
                <span class="os-icon-wrapper"
                  *ngIf="user.osInfo?.os == 'win32' || user.osInfo?.os == 'linux' || user.osInfo?.os == 'darwin'">
                  <img [src]="getOSIconUrl(user.osInfo.os)" alt="OS Icon" class="os-icon">
                </span>
                <span class="info-text">{{ getOSInfo(user.osInfo) }}</span>
              </div>
              <!-- Agent Health Info -->
              <div *ngIf="getUserHealthState(user) !== 'UNKNOWN' || user?.appInfo?.version || user?.agentIntegrity"
                class="action-menu-info-row more-button-dropdowns cursor-pointer"
                [ngClass]="getHealthStatusColorClass(user)"
                (mouseenter)="showHealthTooltip($event, user)"
                (mouseleave)="hideHealthTooltip(user)">
                <span class="material-symbols-outlined action-menu-icon"
                  [ngClass]="[getHealthStatusColorClass(user), getUserHealthState(user) == 'UNHEALTHY' ? 'animate-pulse' : '']">
                  {{ getHealthStatusIcon(user) }}
                </span>
                <span class="info-text font-medium" [ngClass]="getHealthStatusColorClass(user)">{{ getHealthStatusLabel(user) }}</span>
              </div>
            </mat-menu>
          </div>
          <div class="actions-container actions-container--unified" *ngIf="(getUserStatusType(user) == 'invited')">
            <span class="action-icon material-symbols-outlined more-actions cursor-pointer"
              [matMenuTriggerFor]="invitedMoreMenu" matTooltip="More actions">
              more_horiz
            </span>
            <mat-menu #invitedMoreMenu="matMenu" xPosition="before" class="employee-actions-menu"
              panelClass="employee-actions-menu">
              <div class="action-menu-group-label" (click)="$event.stopPropagation()">Onboarding</div>

              <button type="button" mat-menu-item class="action-menu-item" [matMenuTriggerFor]="invitedDownloadMenu"
                (click)="trackTableActionMenu('download_agent')">
                <span class="material-symbols-outlined action-menu-icon">download</span>
                <span>Download installer</span>
              </button>

              <button type="button" mat-menu-item class="action-menu-item"
                *ngIf="isAdmin && checkIsActive() && !expired"
                (click)="trackTableActionMenu('edit'); openModalFire(user.id)">
                <span class="material-symbols-outlined action-menu-icon">edit</span>
                <span>Edit Employee</span>
              </button>

              <ng-container *ngIf="isAdmin && checkIsActive()">
                <mat-divider class="action-menu-divider"></mat-divider>
                <button type="button" mat-menu-item class="action-menu-item action-menu-item--danger"
                  (click)="trackTableActionMenu('delete'); deleteUser(user.id, user)">
                  <span class="material-symbols-outlined action-menu-icon">delete</span>
                  <span>Delete Employee</span>
                </button>
              </ng-container>
            </mat-menu>
            <mat-menu #invitedDownloadMenu="matMenu" xPosition="before">
              <button mat-menu-item *ngIf="!isDownloadSoftwareTypeLocked('silent')"
                [matMenuTriggerFor]="invitedInvisibleTracking">Hidden</button>
              <button mat-menu-item *ngIf="isDownloadSoftwareTypeLocked('silent')" class="download-menu-item--locked"
                (click)="onLockedDownloadSoftwareTypeClick('silent')">
                Hidden
                <mat-icon class="download-menu-lock" aria-hidden="true">lock</mat-icon>
              </button>
              <button mat-menu-item [matMenuTriggerFor]="invitedSelfControl">Employee Controlled</button>
              <button mat-menu-item *ngIf="!isDownloadSoftwareTypeLocked('restricted')"
                [matMenuTriggerFor]="invitedAdminControl">Admin Controlled</button>
              <button mat-menu-item *ngIf="isDownloadSoftwareTypeLocked('restricted')"
                class="download-menu-item--locked" (click)="onLockedDownloadSoftwareTypeClick('restricted')">
                Admin Controlled
                <mat-icon class="download-menu-lock" aria-hidden="true">lock</mat-icon>
              </button>
            </mat-menu>
            <mat-menu #invitedSelfControl="matMenu" xPosition="before">
              <button mat-menu-item (click)="downloadRustGeneralAgent(user)">Windows 10 &amp; 11</button>
              <button mat-menu-item *ngFor="let item of generalDownloads" (click)="downloadGeneralAgent(item.label)">
                {{ item.label }}
              </button>
            </mat-menu>
            <mat-menu #invitedInvisibleTracking="matMenu" xPosition="before">
              <button mat-menu-item (click)="autoResetPasswordRust('Windows', user)">Windows 10 &amp; 11</button>
              <button mat-menu-item *ngFor="let item of silentDownloads" (click)="autoResetPassword(item.label, user)">
                {{ item.label }}
              </button>
            </mat-menu>
            <mat-menu #invitedAdminControl="matMenu" xPosition="before">
              <button mat-menu-item (click)="downloadRustAdminControlAgent('Windows', user)">Windows 10 &amp;
                11</button>
              <button mat-menu-item *ngFor="let item of generalDownloads"
                (click)="downloadAdminControlAgent(item.label, user)">
                {{ item.label }}
              </button>
            </mat-menu>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="table-footer">
  <div *ngIf="loadWaiter" class="skeleton-container">
    <ngx-skeleton-loader count="6"
      [theme]="{ 'border-radius': '2', height: '50px', width: '100%' }"></ngx-skeleton-loader>
  </div>
  <div *ngIf="!loadWaiter && filteredUserList && !filteredUserList.length" class="empty-list-container">
    <div class="empty_list z-depth-2 remove-border">
      <img src="assets/images/empty_list.png" alt="empty list image" />
    </div>
    <app-optional-setup-help-links></app-optional-setup-help-links>
  </div>
</div>